import cx from 'clsx';
import React from 'react';

type Props = {
  className?: string;
  centeredX?: boolean;
  centered?: boolean;
  overlay?: boolean | string;
  blur?: boolean;
  size?: number;
  label?: string;
};

const preventActions = (event: any) => {
  event.stopPropagation();
  return false;
};

export const Spinner = ({ className, size = 36, centeredX = false, centered = false, overlay = false, blur = false, label }: Props) => {
  const overlayColor = typeof overlay === 'string' ? overlay : overlay ? 'bg-white/50' : undefined;

  return (
    <React.Fragment>
      <span
        className={cx(
          centeredX && 'flex place-content-center place-items-center',
          centered && 'absolute top-1/2 left-1/2 z-50 -translate-x-1/2 -translate-y-1/2',
          label && 'flex flex-row items-center gap-2',
          className,
        )}
        data-testid="spinner"
      >
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="animate-spin fill-current" width={size} height={size}>
          <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25" />
          <path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z" />
        </svg>
        {label && <span className="ml-2">{label}</span>}
      </span>
      {overlay && <span onClick={preventActions} className={cx('absolute inset-0 z-40', overlayColor, blur && 'backdrop-blur-[2px]')} />}
    </React.Fragment>
  );
};
